import type { SaleItem } from '@repo/shared-types';
import { formatCurrency } from '@repo/ui/lib/format/format-currency';
import { Check, Package } from 'lucide-react';

interface CashierSaleItemProps {
  item: SaleItem;
  isSelected: boolean;
  onToggle: () => void;
}

export function CashierSaleItem({ item, isSelected, onToggle }: CashierSaleItemProps) {
  return (
    <button
      onClick={onToggle}
      className={`
        flex items-center gap-3 w-full rounded-lg border-2 px-3 py-3 transition-all duration-150 cursor-pointer text-left
        ${
          isSelected
            ? 'border-primary bg-primary/5 shadow-sm'
            : 'border-neutral-100 bg-white hover:border-neutral-200 hover:bg-neutral-50'
        }
      `}
    >
      {/* Selection indicator */}
      <div
        className={`
          size-7 rounded-full shrink-0 flex items-center justify-center transition-colors duration-150
          ${isSelected ? 'bg-primary text-white' : 'border-2 border-neutral-300 bg-white'}
        `}
      >
        {isSelected && <Check className="size-4" strokeWidth={3} />}
      </div>

      {/* Product info */}
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <Package className="size-4 text-neutral-400 shrink-0" />
        <span className="font-medium text-neutral-800 truncate text-sm md:text-base">
          {item.product.name}
        </span>
        {item.quantity > 1 && (
          <span className="text-xs font-medium text-neutral-500 bg-neutral-100 px-1.5 py-0.5 rounded shrink-0">
            x{item.quantity}
          </span>
        )}
      </div>

      {/* Price */}
      <span className="text-base font-bold text-neutral-800 shrink-0">
        {formatCurrency((item.price ?? item.product.price) * item.quantity)}
      </span>
    </button>
  );
}
